import { InterpolationFunction, Styles, ThemeProps } from 'styled-components';
import { css, StyledComponentClass } from '../styled-components';
export const deprecatedCss = css(["text-decoration:line-through;color:#bdccd3;"]);